var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.5483 6.04545C13.5483 8.00355 11.9186 9.59091 9.90829 9.59091C7.89798 9.59091 6.26829 8.00355 6.26829 6.04545C6.26829 4.08735 7.89798 2.5 9.90829 2.5C11.9186 2.5 13.5483 4.08735 13.5483 6.04545ZM6.37988 10.7402C4.51323 10.7402 3 12.2535 3 14.1201C3 15.9868 4.51323 17.5 6.37988 17.5H13.6201C15.4868 17.5 17 15.9868 17 14.1201C17 12.2535 15.4868 10.7402 13.6201 10.7402H6.37988Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.2f96ef476cdb55a9e5a27f2cde31f236.svg";
export { ForwardRef as ReactComponent };